export default {
    install(Vue) {
        const msjpusher = new Vue()
        Vue.prototype.$msjpusher = msjpusher

        Pusher.logToConsole = true;

        let pusher = new Pusher('547ed719632470765105', {
          cluster: 'us2'
        });
    
        let channel = pusher.subscribe('my-channel');
        channel.bind('my-event', function(data) {
          msjpusher.$emit(data.metodo, data.datos)
        });

        
    }
}